import {
  maskFieldValue,
  maskFullName,
  maskFullNameWithPatternAndConfig,
} from '@/src/tools/mask';

export enum EType {
  All = 'All',
  New = 'New',
  Returning = 'Returning',
  AbandonedCheckout = 'AbandonedCheckout',
  Subscriber = 'Subscriber',
}

export const fieldValueGenerator = (
  _fieldName,
  customerInfoFields,
  display,
  fullNameAutoPopulate?,
  isDetails = false,
) => {
  if (_fieldName === 'Full Name' || _fieldName === 'Cross-border Name') {
    const getFieldValue = (fieldsArr, fieldName) => {
      const fieldObj = fieldsArr.find(
        (f) => f?.field?.name?.toLowerCase() === fieldName.toLowerCase(),
      );
      return fieldObj?.value && fieldObj.value.length > 0
        ? fieldObj.value[0]
        : '';
    };
    const firstName = getFieldValue(customerInfoFields, 'First Name');
    const lastName = getFieldValue(customerInfoFields, 'Last Name');

    if (isDetails) {
      return maskFullNameWithPatternAndConfig(
        lastName,
        firstName,
        display,
        fullNameAutoPopulate,
      );
    } else {
      return maskFullName(lastName, firstName, display);
    }
  } else {
    return maskFieldValue(_fieldName, display);
  }
};
